<template>
  <div>
    <p class="cm-mg-p-wzd">1.1 {{ $t('fertilization.budgeted_card_info') }}</p>
    <hr />
    <br />
    <div class="row">
      <div class="col-md-6">
        <label>{{ $t('common_words.year') }}: *</label>
        <el-date-picker
          v-if="renderComponent"
          class="date-ced"
          v-model="model.year"
          type="year"
          @change="fillDate"
          :placeholder="$t('common_words.year_selection')"
        >
        </el-date-picker>
      </div>
      <div class="col-md-6">
        <label>{{ $t('fertilization.fertilizing_type') }}: *</label>
        <br />
        <el-select
          clearable
          filterable
          class="select-primary custom-width-select required shadow-sm fer-type"
          size="large"
          v-model="model.type"
          @change="getFarm"
          :placeholder="`${$t('common_words.select')}...`"
        >
          <el-option
            class="select-primary"
            value="Finca"
            :label="$t('common_words.farm')"
          ></el-option>
          <el-option
            class="select-primary"
            value="Lote"
            :label="$t('common_words.allotment')"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-6">
        <label>{{ $t('common_words.farm') }}: *</label>
        <br />
        <el-select
          clearable
          filterable
          class="select-primary custom-width-select required shadow-sm farm-fer"
          size="large"
          v-model="model.farm_id"
          @change="getLots"
          :placeholder="`${$t('common_words.select')}...`"
        >
          <el-option
            v-for="(option, index) in farms"
            class="select-primary"
            :value="option.id"
            :label="option.name"
            :key="index + '' + option.id"
          ></el-option>
        </el-select>
      </div>
      <div class="col-md-6" v-if="model.type == 'Lote'">
        <label>{{ $t('common_words.allotment') }}: *</label>
        <br />
        <el-select
          clearable
          filterable
          class="select-primary custom-width-select required shadow-sm lot-fer"
          size="large"
          v-model="model.lot_id"
          @change="fillLot"
          :placeholder="`${$t('common_words.select')}...`"
        >
          <el-option
            v-for="(option, index) in lots"
            class="select-primary"
            :value="option.id"
            :label="option.name"
            :key="index + '' + option.id"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-3">
        <label class="text-transform-none"
          >{{ $t('common_words.area') }}: *</label
        >
        <br />
        <el-select
          clearable
          class="select-primary custom-width-select area-ced shadow-sm"
          size="large"
          v-model="model.area"
          :placeholder="`${$t('common_words.select')}...`"
          filterable
        >
          <el-option
            value="Producción"
            :label="$t('common_words.production')"
          ></el-option>
          <el-option
            value="Plantilla"
            :label="$t('production.template')"
          ></el-option>
        </el-select>
      </div>
      <div class="col-md-2">
        <fg-input
          type="number"
          :label="`${$t('production.hectares')}:`"
          min="0"
          @change="fillHectares"
          v-model="model.hectares"
          v-validate="modelValidations.hectares"
          name="production.hectares"
          :error="getError('production.hectares', true)"
        >
        </fg-input>
      </div>
      <div class="col-md-4">
        <fg-input
          type="number"
          :label="`${$t('production.production_per_hectare')}:`"
          min="0"
          v-model="model.boxes_per_hectare"
          v-validate="modelValidations.prod_by_hectares"
          name="production.production_per_hectare"
          :error="getError('production.production_per_hectare', true)"
        >
        </fg-input>
      </div>
      <div class="col-md-3">
        <fg-input
          type="number"
          :label="`${$t('common_words.rmr')}: *`"
          min="0"
          v-model="model.trm"
          v-validate="modelValidations.trm"
          name="common_words.rmr"
          :error="getError('common_words.rmr', true)"
        >
        </fg-input>
      </div>
    </div>
    <div class="row" v-show="errorAlert">
      <div class="col-lg-12">
        <br />
        <el-alert
          ref="error_alert"
          :title="$t('common_words.errors')"
          type="error"
          >{{ error }}</el-alert
        >
      </div>
    </div>
  </div>
</template>

<script>
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinForm from 'src/mixins/forms/mixin-form';
import moment from 'moment';
import { Axios } from 'src/class/Axios.js';

export default {
  data() {
    return {
      model: {
        year: null,
        area: null,
        hectares: null,
        type: null,
        farm_id: null,
        lot_id: null,
        boxes_per_hectare: null,
        trm: null,
      },
      modelValidations: {
        hectares: {
          decimal: true,
          min_value: 0,
          required: true,
        },
        prod_by_hectares: {
          decimal: true,
          min_value: 0,
          required: true,
        },
        trm: {
          decimal: true,
          min_value: 0,
          required: true,
        },
      },
      businesses: null,
      farms: [],
      lots: [],
    };
  },

  mixins: [mixinMasters, MixinForm, MixinPermissions],
  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', res, this.model);
          let others = [];
          this.$emit('fillbudgetedCardForm', 'firstStep', {
            names_business: others,
          });
          return res;
        })
        .then((resp) => {
          if (!resp) return resp;

          if (this.model.year == null) {
            this.highlightItem('date-ced');
            return false;
          } else if (this.model.type == null) {
            this.highlightItem('fer-type');
            return false;
          } else if (this.model.farm_id == null) {
            this.highlightItem('farm-fer');
            return false;
          } else if (this.model.area == null) {
            this.highlightItem('area-ced');
            return false;
          } else if (this.model.type == 'Lote' && this.model.lot_id == null) {
            this.highlightItem('lot-fer');
            return false;
          } else {
            return true;
          }
        });
    },

    fillHectares() {
      sessionStorage.setItem('hectares', this.model.hectares);
    },

    fillDate() {
      sessionStorage.setItem(
        'year_budgeted',
        moment(String(this.model.year)).format('YYYY')
      );
    },

    fillLot() {
      sessionStorage.setItem('lot_id', this.model.lot_id);
    },

    getFarm() {
      this.showHideLoading(true);
      sessionStorage.setItem('type_budgeted', this.model.type);

      Axios.getMasters('farms/farms/only')
        .then((response) => {
          this.farms = response.data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showMessageErrors(error);
          this.showHideLoading();
        });
    },

    getLots() {
      this.showHideLoading(true);

      Axios.getMasters('lots/' + this.model.farm_id)
        .then((response) => {
          this.lots = response.data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showMessageErrors(error);
          this.showHideLoading();
        });
    },
  },

  created() {
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Axios.getMasters('businesses')
        .then((response) => {
          this.businesses = response.data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showMessageErrors(error);
          this.showHideLoading();
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.showHideLoading(true);

    let editForm = {};

    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));

      this.model.id = editForm.id;
      this.model.year = moment(String(editForm.year)).format('YYYY-M-D');
      this.model.area = editForm.area;
      this.model.hectares = editForm.hectares;
      this.model.type = editForm.type;
      this.model.farm_id = editForm.farm_id;
      this.model.lot_id = editForm.lot_id;
      this.model.boxes_per_hectare = editForm.boxes_per_hectare;
      this.model.trm = editForm.trm;

      sessionStorage.setItem('hectares', this.model.hectares);
      sessionStorage.setItem(
        'year_budgeted',
        moment(String(editForm.year)).format('YYYY')
      );
      sessionStorage.setItem('type_budgeted', this.model.type);
      sessionStorage.setItem('lot_id', this.model.lot_id);

      this.getFarm();
      this.getLots();

      //this.showHideLoading();
    }
  },
};
</script>
<style></style>
